module.exports = __webpack_public_path__ + "img/pdf-watermark.ca81fa3a.png";